/**
 * Custom query keys for direct-reports queries that don't use shared service hooks.
 *
 * NOTE: Most direct-reports queries are already handled by feature service hooks.
 * Use the service-level query keys for
 * invalidating the standard list/detail queries. These keys are only for the
 * custom infinite query.
 */
export const DIRECTREPORTS_QUERY_KEYS = {
  infinite: ['directReports', 'infinite'] as const,
  infiniteList: (organizationId: string, managerId: string, pageSize: number) =>
    [
      ...DIRECTREPORTS_QUERY_KEYS.infinite,
      { organizationId, managerId, pageSize },
    ] as const,
}
